

<div class="row">
  <div class="col-md-12 col-xl-12">
    <div class="card">
      <div class="card-header background-white pad4">
        <label class="title font-size-20px margin-top-0px margin-bottom-0px">Edit Coded Values</label>
        <button type="button" class="close button:focus" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="card-body">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="row my-pro-form margin-t-form">
            <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label class="lab-size1"> Long Value </label>
                </div>
                <div class="col-md-6">

                  <!--<input type="text" class="form-control form-control-patient font-size-20px" placeholder="Long Value">-->
                  <input type="text" class="form-control form-control-patient font-size-20px"
                         id="CurrentEditLongCodeTypeValueRequest.LongValue"
                         [(ngModel)]="CurrentEditLongCodeTypeValueRequest.LongValue"
                         name="CurrentEditLongCodeTypeValueRequest.LongValue">

                </div>


              </div>

            </div>
          </div>
          <div class="row my-pro-form margin-t-form">
            <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label class="lab-size1"> Short Value </label>
                </div>
                <div class="col-md-6">

                  <!--<input type="text" class="form-control form-control-patient font-size-20px" placeholder="Short Value">-->
                  <input type="text" class="form-control form-control-patient font-size-20px"
                         id="CurrentEditLongCodeTypeValueRequest.ShortValue"
                         [(ngModel)]="CurrentEditLongCodeTypeValueRequest.ShortValue"
                         name="CurrentEditLongCodeTypeValueRequest.ShortValue">

                </div>


              </div>

            </div>
          </div>


          <div class="col-md-12">
            <div class="row margin-top-30px margin-bottom-30px">

              <div class="col-md-6 padding-left-0px padding-right-24px">
                <button class="btn bs hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px padding-left-8px float-right" (click)="activeModal.dismiss('Cross click')" type="button">Cancel</button>
              </div>
              <div class="col-md-6 padding-left-0px padding-right-24px">
                <button type="submit" [disabled]="!f.valid" class="btn btn-primary hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px float-left">Save</button>
                <!--<button class="btn btn-primary hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px float-left" type="button">Save</button>-->
              </div>

            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>





